import React from "react";
import { classNames } from "primereact/utils";
import styles from "./BookingDetails.module.scss";
import { IService, IEmployeeAvailability } from "../../../models";
import { IStudioSelectItemModel } from "../../../../../../common/infrastructure/models/studioSelectItemModel";
import { IUserModel } from "../../../../../../common/infrastructure/hooks/useAuthentication";
import { PriceDisplay } from "../../../../../../common/components/PriceDisplay";

interface IBookingDetailsData {
  service: IService;
  employee: IEmployeeAvailability;
  date: string;
  timeRange: string;
  price: number;
  studio?: IStudioSelectItemModel;
  customer?: IUserModel | null;
}

interface IBookingDetailsProps {
  bookingDetails: IBookingDetailsData;
  className?: string;
}

export const BookingDetails = ({
  bookingDetails,
  className,
}: IBookingDetailsProps) => {
  const { service, employee, date, timeRange, price, studio } = bookingDetails;

  const detailRows = [
    {
      icon: "🏢",
      label: "Обект",
      value: studio?.name || "Неизвестен обект",
      delay: "0.1s",
    },
    {
      icon: "✂️",
      label: "Услуга",
      value: service.name,
      delay: "0.2s",
    },
    {
      icon: "👤",
      label: "Специалист",
      value: employee.name,
      delay: "0.3s",
    },
    {
      icon: "📅",
      label: "Дата",
      value: date,
      delay: "0.4s",
    },
    {
      icon: "⏰",
      label: "Час",
      value: timeRange,
      delay: "0.5s",
    },
  ];

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.header}>
        <h3 className={styles.title}>Обобщение на резервацията</h3>
      </div>

      <div className={styles.detailsGrid}>
        {detailRows.map((row, index) => (
          <div
            key={row.label}
            className={styles.detailRow}
            style={{ animationDelay: row.delay }}
          >
            <div className={styles.detailLeft}>
              <span className={styles.detailIcon}>{row.icon}</span>
              <span className={styles.detailLabel}>{row.label}:</span>
            </div>
            <span className={styles.detailValue}>{row.value}</span>
          </div>
        ))}
      </div>

      {/* Service Description */}
      {service.description && (
        <div className={styles.descriptionSection}>
          <h4 className={styles.descriptionTitle}>Описание на услугата</h4>
          <p className={styles.descriptionText}>
            {service.description.replace(/<[^>]*>/g, "")}
          </p>
        </div>
      )}

      {/* Summary Card */}
      <div className={styles.summaryCard}>
        <div className={styles.summaryHeader}>
          <span className={styles.summaryLabel}>Обща сума:</span>
          <span className={styles.summaryAmount}>
            <PriceDisplay
              minPrice={service.minPrice}
              maxPrice={service.maxPrice}
            />
          </span>
        </div>
        <div className={styles.summaryNote}>
          <span className={styles.noteIcon}>ℹ️</span>
          <span className={styles.noteText}>
            Плащането се извършва на място.
          </span>
        </div>
      </div>
    </div>
  );
};
